import React, { useState } from 'react'
import { Paper, Tab, Tabs, Typography } from '@material-ui/core'
import { useLocation } from 'react-router-dom'

import { Styles } from '../Styles'
import { LegalTab } from './LegalTab'
import { useStyles } from './styles'

const APP_CONFIG_TABS = [
  { id: 'styles', label: 'Estilos' },
  { id: 'legal', label: 'Legales' },
] as const

const tabIndexFromQuery = (search: string) => {
  const tab = new URLSearchParams(search).get('tab')
  const index = APP_CONFIG_TABS.findIndex(option => option.id === tab)
  return index >= 0 ? index : 0
}

const AppConfig: React.FC = () => {
  const classes = useStyles()
  const location = useLocation()
  const [tab, setTab] = useState(() => tabIndexFromQuery(location.search))

  return (
    <Paper className={classes.pageCard} elevation={2}>
      <Typography variant="h6" className={classes.pageTitle}>
        Configuraciones de la App
      </Typography>
      <Tabs
        value={tab}
        onChange={(_event, value) => setTab(value)}
        indicatorColor="primary"
        textColor="primary"
        className={classes.tabs}
      >
        {APP_CONFIG_TABS.map(option => (
          <Tab key={option.id} label={option.label} />
        ))}
      </Tabs>
      {tab === 0 && <Styles />}
      {tab === 1 && <LegalTab />}
    </Paper>
  )
}

export { AppConfig as LegalTexts }
